import React, { Component } from 'react'
import Footer from '../../../../_components/common/Footer';
import NavBar from '../../../../_components/common/Navbar';

import { HotTable } from '@handsontable/react';
import 'handsontable/dist/handsontable.full.css'

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../../_components/common/Form2/index.css';
import ModalNew2 from '../../../../_components/common/ModalNew2';
import { CommonBreadCrumb } from '../../../../_components/common/CommonBreadCrumb';
import Page404 from '../../../404page';
import { LoaderComp } from '../../../../_components/common/LoaderComp/Loadercomp';
import * as Papa from 'papaparse';

import { connect } from 'react-redux';

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

//validation
import { validation } from '../../UploadDemographicData/validation';

import { organisationAction } from '../../../../_actions/organisation.action';
import { manageBatchActions } from '../../../../_actions/organisations/manageBatchList.action';
import { UploadAssessmentAction } from '../../../../_actions/organisations/UploadAssessmentAction.action';

import '../../UploadDemographicData';
import './uploadAssessmentResponse.css'

class UploadAssessmentResponse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orgId: 0,
            sellerId: 0,
            csvUploaded: false,

            batchList: [],

            chooseFile: false,
            csvData: [],
            validateDisability: false,
            uploadDisability: false,
            csvErrorPosition: {},
            work_experience: 50,
            validationText: 'VALIDATE',
            isChooseFileDisabled: false,


            currentInstrumentId: 0,
            currentBatchId: null,

            readOnlyCsv: false,
            breadCrumbData: [],


            hasProperOrgId: true,
            idLoader: false,
            errSaveIndex: [],

            uploadloader: false,
            showResponseResult: false,
            showResultView: false,

        }
    }

    componentDidMount() {
        const { dispatch } = this.props;

        let orgIdFromPath = this.props.location.pathname.match(/\d/g);
        orgIdFromPath = orgIdFromPath.join("");

        dispatch(organisationAction.getOrganisation((callback_Data) => {
            let hasId = false;
            for (const element of callback_Data.data.organisation_list) {
                if (element.id == orgIdFromPath) {
                    hasId = true;
                    break;  // We can break the loop once we find a match
                }
            }

            this.setState({
                hasProperOrgId: hasId,
                idLoader: false,
            });
        }));
        this.setState({
            orgId: orgIdFromPath
        }, () => {
            let sellerIdLocal = localStorage.getItem('seller_id')
            let orgIdLocal = localStorage.getItem('orgId')
            if (sellerIdLocal !== 'null' || orgIdLocal !== 'null') {
                this.setState(prevState => ({
                    breadCrumbData: [
                        {
                            link: '/admin/app/dashboard',
                            name: 'ADMIN'
                        }, {
                            link: '/admin/app/organisation',
                            name: 'ORGANISATION'
                        }, {
                            link: `/admin/app/organisation/${prevState.orgId}`,
                            name: 'ORGANISATION DETAILS'
                        }, {
                            link: '',
                            name: 'UPLOAD ASSESSMENTS RESPONSES'
                        }
                    ]
                }), () => {
                    if (orgIdLocal !== 'null') {
                        this.setState({
                            breadCrumbData: [
                                {
                                    link: '/admin/app/dashboard',
                                    name: 'ADMIN'
                                }, {
                                    link: '',
                                    name: 'UPLOAD ASSESSMENTS RESPONSES'
                                }
                            ],
                        })
                    }
                })
            } else {
                this.setState(prevState => ({
                    breadCrumbData: [
                        {
                            link: '/admin/app/dashboard',
                            name: 'ADMIN'
                        }, {
                            link: '/admin/app/organisation',
                            name: 'ORGANISATION'
                        }, {
                            link: `/admin/app/organisation/${prevState.orgId}`,
                            name: 'ORGANISATION DETAILS'
                        }, {
                            link: '',
                            name: 'UPLOAD ASSESSMENTS RESPONSES'
                        }
                    ]
                }));
            }
        })
    }


    componentDidUpdate(prevProps, prevState) {
        const { demoGraphicCsvUpload } = this.props

        if (prevProps.demoGraphicCsvUpload !== demoGraphicCsvUpload) {
            if (demoGraphicCsvUpload.demoGraphicCsvUpload_error === false && demoGraphicCsvUpload.demoGraphicCsvUpload_loading === false) {
                let toastIdDemoGrpahicUpload = toast['info'](`CSV UPLOADED SUCCESSFULLY`, {
                    position: toast.POSITION.BOTTOM_LEFT,
                    autoClose: 1500,
                });

                toast.update(toastIdDemoGrpahicUpload, {
                    render: `CSV UPLOADED SUCCESSFULLY`,
                    type: toast.TYPE.INFO,
                    className: 'styleToastSuccess'
                })
            } else if (demoGraphicCsvUpload.demoGraphicCsvUpload_error === true) {

            }
        }

        if (prevProps.organisationList !== this.props.organisationList) {
            if (this.props.organisationList.length !== 0) {
                let sellerId = 0
                for (let i = 0; i < this.props.organisationList.length; i++) {
                    const element = this.props.organisationList[i];
                    if (element.id == this.state.orgId) {
                        sellerId = element.seller__id
                    }
                }
                this.setState({
                    sellerId
                }, () => {
                    const { dispatch } = this.props;
                    const { orgId, sellerId } = this.state;

                    dispatch(manageBatchActions.getBatchList({
                        orgId,
                        sellerId,
                    }));

                    dispatch(manageBatchActions.allotAssessmentInstrumentListAction({
                        sellerId,
                        orgId
                    }));

                })
            }
        }
    }


    chooseFileFunc = (showModal) => {
        this.setState({
            chooseFile: showModal
        })


    }

    csvJSON(csv) {
        const lines = csv;
        const result = [];
        const headers = lines[0];

        for (let i = 1; i < lines.length; i++) {
            const obj = {};
            const currentline = lines[i];

            for (let j = 0; j < headers.length; j++) {
                obj[headers[j]] = currentline[j];
            }

            result.push(obj);
        }

        return result;
    }

    validateCsvFunc = () => {
        this.setState(
            prevState => ({
                uploadDisability: false,
                validateDisability: !prevState.validateDisability,
                validationText: prevState.validationText === 'VALIDATE' ? 'VALIDATING...' : 'GETTING CSV READY TO EDIT...'
            }),
            () => {
                setTimeout(this.performValidation, 1300);
            }
        );
    }

    performValidation = () => {
        if (this.state.validationText === 'VALIDATING...') {
            this.validateCsvData();
        } else if (this.state.validationText === 'GETTING CSV READY TO EDIT...') {
            this.prepareForEditing();
        }
        this.toggleValidateDisability();
    }

    validateCsvData = () => {
        if (this.state.csvData.length === 0) return;

        const { validationResult, newCsvData } = this.validateRows();

        if (validationResult.isValid) {
            this.handleSuccessfulValidation(newCsvData);
        } else {
            this.handleFailedValidation(validationResult, newCsvData);
        }
    }

    validateRows = () => {
        let isValid = true;
        const saveIndex = [];
        const newCsvData = [this.state.csvData[0]]; // Keep the header row
        const emailSet = new Set();
        const duplicateEmails = new Set();

        for (let i = 1; i < this.state.csvData.length; i++) {
            const row = this.state.csvData[i];
            const isRowEmpty = row.every(cell => cell === '' || cell === undefined);

            if (!isRowEmpty) {
                const { rowHasError, errorColumns } = this.validateRow(row, emailSet, duplicateEmails);

                if (rowHasError) {
                    isValid = false;
                    saveIndex.push({ row: newCsvData.length, col: errorColumns });
                }

                newCsvData.push(row);
            }
            // Empty rows are skipped and not added to newCsvData
        }

        return { validationResult: { isValid, saveIndex, duplicateEmails }, newCsvData };
    }

    validateRow = (row, emailSet, duplicateEmails) => {
        const isRowEmpty = row.every(cell => cell === '' || cell === undefined);
        if (isRowEmpty) return { rowHasError: false, errorColumns: [] };

        let rowHasError = false;
        const errorColumns = [];

        const emailValidationResult = this.validateEmail(row[0], emailSet, duplicateEmails);
        if (emailValidationResult.hasError) {
            rowHasError = true;
            errorColumns.push(0);
        }

        for (let j = 1; j < row.length; j++) {
            if (row[j] === '' || row[j] === undefined) {
                rowHasError = true;
                errorColumns.push(j);
            }
        }

        return { rowHasError, errorColumns };
    }

    validateEmail = (email, emailSet, duplicateEmails) => {
        if (email === '' || email === undefined || !validation.isEmailAddress(email)) {
            return { hasError: true };
        }

        if (emailSet.has(email)) {
            duplicateEmails.add(email);
            return { hasError: true };
        }

        emailSet.add(email);
        return { hasError: false };
    }

    handleSuccessfulValidation = (newCsvData) => {
        toast.info(`CSV VALIDATED SUCCESSFULLY`, {
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 1500,
        });
        this.setState({
            csvData: newCsvData, // This now contains only non-empty rows
            readOnlyCsv: true,
            validationText: 'EDIT CSV',
            uploadDisability: true,
        });
    }

    handleFailedValidation = (validationResult, newCsvData) => {
        const errorMessages = this.generateErrorMessages(validationResult.duplicateEmails);
        toast.error(errorMessages.join('\n'), {
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 5000,
        });
        this.showErrorHighlightHOT(validationResult.saveIndex);
        this.setState({
            csvData: newCsvData,
            readOnlyCsv: true,
            uploadDisability: false,
            validationText: 'EDIT CSV'
        });
    }

    generateErrorMessages = (duplicateEmails) => {
        const errorMessages = [];
        if (duplicateEmails.size > 0) {
            errorMessages.push(`Duplicate emails found: ${Array.from(duplicateEmails).join(', ')}`);
        }
        errorMessages.push('CSV VALIDATION FAILED');
        return errorMessages;
    }

    prepareForEditing = () => {
        this.setState({
            readOnlyCsv: false,
            uploadDisability: false,
            validationText: 'VALIDATE'
        });
    }

    toggleValidateDisability = () => {
        this.setState(prevState => ({
            validateDisability: !prevState.validateDisability,
        }));
    }

    showErrorHighlightHOT(saveIndex) {
        this.setState({
            errSaveIndex: saveIndex,
        })
    }

    uploadCsvFunc = () => {
        const { dispatch } = this.props;
        const uploadingCsvResponseData = this.csvJSON(this.state.csvData)
        uploadingCsvResponseData.map((val, index) => {
            if ((val.participant === '' && val.participant === undefined)) {
                uploadingCsvResponseData.splice(index, 1)
            }
            return val; // Add this line to address the SonarQube warning
        })

        const UploadingData = {
            details_length: uploadingCsvResponseData.length,
            organisation: this.state.orgId,
            seller: this.state.sellerId,
            instrument: this.state.currentInstrumentId,
            details: uploadingCsvResponseData
        }

        dispatch(
            UploadAssessmentAction.UploadAssessmentResponsesActionApi(
                UploadingData,
                {
                    sellerId: this.state.sellerId,
                    orgId: this.state.orgId
                },
                manageBatchActions.allotAssessmentInstrumentListAction,
                (UploadAssessmentActionApi_Data) => {
                    if (UploadAssessmentActionApi_Data) {
                        if (UploadAssessmentActionApi_Data.data.status === true) {
                            this.setState({
                                csvData: [],
                                errSaveIndex: [],
                                csvUploaded: true,
                            })
                        }
                        this.setState({
                            uploadloader: false,
                            validateDisability: true,
                            validationText: "VALIDATE",
                            isChooseFileDisabled: false,
                        })
                    } else {
                        this.setState({
                            uploadloader: false,
                            validateDisability: true,
                            validationText: "EDIT CSV",
                            csvUploaded: false
                        })
                    }
                }
            )
        )

        this.setState({
            uploadloader: true,
            currentInstrumentId: 0,
            validateDisability: false,
            isChooseFileDisabled: true,
        })
    }

    cellbeforechange = (c, s) => {
        this.state.csvData[c[0][0]][c[0][1]] = c[0][3]

        let editedErrored = false

        this.state.errSaveIndex.map(indexes => {
            indexes.col.map(colD => {
                if (c[0][0] === indexes.row && c[0][1] === colD) {
                    if (c[0][2] !== c[0][3]) {
                        editedErrored = true
                    }
                }
                return colD; // Add this line to address the SonarQube warning
            })
            return indexes; // Add this line to address the SonarQube warning
        })

        if (editedErrored) {
            const errorIndexArr = this.state.errSaveIndex.map(indexes => {
                return {
                    ...indexes,
                    col: indexes.col.filter(colD => {
                        return indexes.row !== c[0][0] || (indexes.row === c[0][0] && colD !== c[0][1])
                    })
                }
            })

            this.setState({
                errSaveIndex: errorIndexArr
            })
        }
    }

    hotAfterValidate = (isValid, value, row, prop, source) => {

    }

    chooseFileAction = (data) => {
        Papa.parse(data, {
            complete: (results) => this.handleParseComplete(results)
        });
    }


    handleParseComplete = (results) => {
        if (this.isFileEmpty(results.data)) {
            this.handleEmptyFile();
            return;
        }

        if (this.hasInvalidColumns(results.data)) {
            this.handleInvalidColumns();
            return;
        }

        if (this.isOnlyHeaderRow(results.data)) {
            this.handleOnlyHeaderRow();
            return;
        }

        const validCsvCount = this.countValidCsvEntries(results.data);

        if (validCsvCount === results.data[0].length) {
            if (this.hasNoDataRows(results.data)) {
                this.handleNoDataRows();
            } else {
                this.processValidCsv(results.data);
            }
        } else {
            this.handleInvalidCsvFormat();
        }

        this.resetValidationState();
    }

    isFileEmpty = (data) => {
        return data.length === 0 || (data.length === 1 && data[0].every(cell => cell === ''));
    }

    handleEmptyFile = () => {
        this.setState({
            csvData: [],
            errSaveIndex: [],
            validateDisability: false,
        }, () => {
            toast.error(`The uploaded file is empty`, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 3000,
            });
        });
    }

    isOnlyHeaderRow = (data) => {
        return data.length === 1;
    }


    handleOnlyHeaderRow = () => {
        this.setState({
            csvData: [],
            errSaveIndex: [],
            validateDisability: false,
        }, () => {
            toast.error(`The CSV file only contains a header row and no data`, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 3000,
            });
        });
    }
    hasNoDataRows = (data) => {
        // Check if there are any non-empty rows after the header
        return data.slice(1).every(row => row.every(cell => cell === ''));
    }
    handleNoDataRows = () => {
        this.setState({
            csvData: [],
            errSaveIndex: [],
            validateDisability: false,
        }, () => {
            toast.error(`The CSV file contains headers but no data rows`, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 3000,
            });
        });
    }



    hasInvalidColumns = (data) => {
        if (data.length === 0) return false;
        const invalidColumns = ['expiry_date', 'full_name', 'short_name', 'gender'];
        const headers = data[0];
        return headers.some(header => invalidColumns.includes(header.toLowerCase()));
    }

    handleInvalidColumns = () => {
        this.setState({
            csvData: [],
            errSaveIndex: [],
            validateDisability: false,
        }, () => {
            toast.error(`CSV contains invalid columns. Please remove expiry_date, full_name, short_name, and gender columns.`, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 3000,
            });
        });
    }

    countValidCsvEntries = (data) => {
        let validCount = 0;
        if (data.length > 0) {
            const element = data[0];
            for (let j = 0; j < element.length; j++) {
                const elem = element[j];
                if (elem === 'participant' || (0 < elem && elem < element.length)) {
                    validCount++;
                }
            }
        }
        return validCount;
    }

    processValidCsv = (data) => {
        let properCsvData = [];
        data.forEach((val, key) => {
            let csvArrayLength = val.length;
            if (csvArrayLength >= 2) {
                if (key !== 0) {
                    let arrayToThisLocation = [];
                    val.forEach((value, index) => {
                        arrayToThisLocation.push(value);
                    });
                    properCsvData.push(arrayToThisLocation);
                } else {
                    properCsvData.push(val);
                }
            }
        });

        properCsvData = properCsvData.filter(csvData => csvData.length > 1);

        this.setState({
            csvData: properCsvData,
            csvUploaded: false,
        }, () => {
            if (this.state.currentInstrumentId !== 0) {
                this.setState({ validateDisability: true });
            }
        });
    }

    handleInvalidCsvFormat = () => {
        this.setState({
            csvData: [],
            errSaveIndex: [],
            validateDisability: false,
        }, () => {
            toast.error(`CSV FORMAT DOESN'T MATCH`, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        });
    }

    resetValidationState = () => {
        this.setState({
            validationText: 'VALIDATE',
            readOnlyCsv: false,
            uploadDisability: false,
        });
    }

    chooseInstrument = (e) => {
        if (e.target.value !== 'Choose an Option...') {
            this.setState({
                currentInstrumentId: parseInt(e.target.value)
            }, () => {
                if (this.state.validateDisability === false && this.state.csvData.length > 0) {
                    this.setState({
                        validateDisability: true
                    })
                }
                if (this.state.validationText === 'EDIT CSV' && this.state.uploadDisability === false) {
                    this.setState({
                        uploadDisability: true,
                    })
                }
            })
        } else {
            this.setState({
                uploadDisability: false,
                currentInstrumentId: 0,
                validateDisability: false,
                readOnlyCsv: false,
                validationText: 'VALIDATE'
            })
        }
    }



    toggle = () => {
        const { dispatch } = this.props;

        this.setState({
            uploadDisability: !this.state.uploadDisability
        }, () => {
            dispatch({
                type: 'REQUEST_UPLOAD_ASSESSMENT_RESPONSES_API',
            })
        })
    }

    resultNavigate = (modalData) => {
        const { dispatch } = this.props
        this.setState({
            showResponseResult: modalData
        })

        dispatch(UploadAssessmentAction.UploadAssessmentResponsesResultListActionApi(parseInt(this.state.orgId), this.state.currentInstrumentId))

    }

    resultToggle = () => {
        this.setState({
            showResponseResult: !this.state.showResponseResult
        })


    }

    viewDetails = (resultId, toggleData) => {
        const { dispatch } = this.props

        this.setState({
            showResultView: toggleData
        })

        const resultPostData = {
            organisation: parseInt(this.state.orgId),
            result: resultId
        }

        dispatch(UploadAssessmentAction.UploadAssessmentResponsesResultViewActionApi(resultPostData, parseInt(this.state.orgId), this.state.currentInstrumentId))

    }


    resultViewToggle = () => {
        this.setState({
            showResultView: !this.state.showResultView
        })
    }

    render() {
        const {
            instrumentList,
            uploaded_assessment_responses_data,
            uploaded_assessment_responses_error,
            uploaded_assessment_responses_result_view_data,
            uploaded_assessment_responses_result_list_data,
        } = this.props;

        if (this.state.idLoader) {
            return this.renderLoader();
        }

        if (!this.state.hasProperOrgId) {
            return <Page404 />;
        }

        return (
            <div className="position-relative custom-container">
                <NavBar />
                <div className="container" style={{ marginTop: 20, marginBottom: 20 }}>
                    {this.renderUploadModal()}
                    {this.renderResultViewModal()}
                    {this.renderResponseResultModal()}
                    <CommonBreadCrumb data={this.state.breadCrumbData} />
                    {this.renderInstrumentSelection(instrumentList)}
                    {this.renderUploadSection()}
                    {this.renderHotTable()}
                    {this.renderChooseFileModal()}
                </div>
                <Footer />
            </div>
        );
    }

    renderLoader() {
        return (
            <div style={{ height: 'calc(100vh - 150px)' }} className="container d-flex justify-content-center">
                <LoaderComp color={'black'} />
            </div>
        );
    }

    renderUploadModal() {
        const { uploaded_assessment_responses_data, uploaded_assessment_responses_error } = this.props;
        const showModal = uploaded_assessment_responses_data.status === true && this.state.uploadDisability === true;

        if (!showModal && !uploaded_assessment_responses_error) return null;

        return (
            <Modal isOpen={this.state.uploadDisability} toggle={this.toggle} centered={true}>
                <ModalHeader toggle={this.toggle} className="bg-black text-white text-uppercase custom-header">
                    {uploaded_assessment_responses_error ? "Error Occurred!" : "Upload Assessment"}
                </ModalHeader>
                <ModalBody>
                    {this.renderUploadModalBody()}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" style={{ borderRadius: 0, margin: '0 10px' }} onClick={this.toggle}>OK</Button>
                </ModalFooter>
            </Modal>
        );
    }

    renderUploadModalBody() {
        const { uploaded_assessment_responses_data, uploaded_assessment_responses_error } = this.props;

        if (uploaded_assessment_responses_error) {
            return "Check csv properly";
        }

        if (uploaded_assessment_responses_data.errors && uploaded_assessment_responses_data.errors.length === this.state.csvData.length - 1) {
            return <p style={{ fontSize: 20, textAlign: 'center', color: 'red' }}>Upload Failed</p>;
        }

        return (
            <div>
                {this.renderUploadErrors()}
                <div>
                    <p>{uploaded_assessment_responses_data ? uploaded_assessment_responses_data.completed_assessments : ''}</p>
                </div>
            </div>
        );
    }

    renderUploadErrors() {
        const { uploaded_assessment_responses_data } = this.props;
        if (!uploaded_assessment_responses_data || !uploaded_assessment_responses_data.errors || uploaded_assessment_responses_data.errors.length === 0) {
            return <p></p>;
        }

        return (
            <div>
                <h5>Errors</h5>
                <ul>
                    {uploaded_assessment_responses_data.errors.map((val, index) => (
                        <li key={index} style={{ fontSize: 14, textAlign: 'center' }}>{JSON.stringify(val)}</li>
                    ))}
                </ul>
            </div>
        );
    }

    renderResultViewModal() {
        const { uploaded_assessment_responses_result_view_data, uploaded_assessment_responses_result_view_loading, uploaded_assessment_responses_result_view_error } = this.props;

        return (
            <Modal isOpen={this.state.showResultView} toggle={this.resultViewToggle} centered={true}>
                <ModalHeader toggle={this.resultViewToggle} className="bg-black text-white text-uppercase custom-header">
                    Result Details
                </ModalHeader>
                <ModalBody>
                    {this.renderResultViewModalBody()}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" style={{ borderRadius: 0, margin: '0 10px' }} onClick={this.resultViewToggle}>OK</Button>
                </ModalFooter>
            </Modal>
        );
    }

    renderResultViewModalBody() {
        const { uploaded_assessment_responses_result_view_data, uploaded_assessment_responses_result_view_loading, uploaded_assessment_responses_result_view_error, uploaded_assessment_responses_result_view_error_data } = this.props;

        if (uploaded_assessment_responses_result_view_loading) {
            return <div>Loading...</div>;
        }

        if (uploaded_assessment_responses_result_view_error) {
            return <div>{uploaded_assessment_responses_result_view_error_data}</div>;
        }

        return (
            <div>
                {this.renderResultViewErrors()}
                {this.renderSuccessfulUploads()}
            </div>
        );
    }

    renderResultViewErrors() {
        const { uploaded_assessment_responses_result_view_data } = this.props;
        if (!uploaded_assessment_responses_result_view_data.errors || uploaded_assessment_responses_result_view_data.errors.length === 0) {
            return null;
        }

        return (
            <div>
                <h5>Failed to upload assessment response.
                </h5>
                <ul className="result-errors">
                    {uploaded_assessment_responses_result_view_data.errors.map((data, index) => (
                        <li key={index}>{JSON.stringify(data)}</li>
                    ))}
                </ul>
            </div>
        );
    }

    renderSuccessfulUploads() {
        const { uploaded_assessment_responses_result_view_data } = this.props;
        if (!uploaded_assessment_responses_result_view_data.assessment_successful_users || uploaded_assessment_responses_result_view_data.assessment_successful_users.length === 0) {
            return null;
        }

        return (
            <div>
                <h5>Successfully uploaded assessment response</h5>
                <ul className="result-errors">
                    {uploaded_assessment_responses_result_view_data.assessment_successful_users.map((data, index) => (
                        <li key={index}>{data}</li>
                    ))}
                </ul>
            </div>
        );
    }

    renderResponseResultModal() {
        return (
            <Modal isOpen={this.state.showResponseResult} toggle={this.resultToggle} centered={true}>
                <ModalHeader toggle={this.resultToggle} className="bg-black text-white text-uppercase custom-header">
                    Result List
                </ModalHeader>
                <ModalBody>
                    {this.renderResponseResultModalBody()}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" style={{ borderRadius: 0, margin: '0 10px' }} onClick={this.resultToggle}>OK</Button>
                </ModalFooter>
            </Modal>
        );
    }

    renderResponseResultModalBody() {
        const { uploaded_assessment_responses_result_list_data, uploaded_assessment_responses_result_list_loading, uploaded_assessment_responses_result_list_error, uploaded_assessment_responses_result_list_error_data } = this.props;

        if (uploaded_assessment_responses_result_list_loading) {
            return <div>Loading...</div>;
        }

        if (uploaded_assessment_responses_result_list_error) {
            return <div>{uploaded_assessment_responses_result_list_error_data}</div>;
        }

        return (
            <div>
                <table className="result-table">
                    <thead>
                        <tr className="result-tr">
                            <th className='result-th'>Id</th>
                            <th className='result-th'>Uploaded date</th>
                            <th className='result-th'>Status</th>
                            <th className='result-th'>View</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderResponseResultRows()}
                    </tbody>
                </table>
            </div>
        );
    }

    renderResponseResultRows() {
        const { uploaded_assessment_responses_result_list_data } = this.props;

        if (!uploaded_assessment_responses_result_list_data) {
            return <tr><td colSpan="4">No data available</td></tr>;
        }

        return uploaded_assessment_responses_result_list_data.map(data => (
            <tr key={data.id} className="result-tr">
                <td className='result-td'>{data.id}</td>
                <td className='result-td'>{data.upload_date}</td>
                <td className='result-td'>{data.completed.toString()}</td>
                <td className='result-td'>
                    <button
                        className='btn btn-red btn-sm'
                        onClick={() => this.viewDetails(data.id, true)}
                        disabled={!data.completed}
                    >
                        View Details
                    </button>
                </td>
            </tr>
        ));
    }

    renderInstrumentSelection(instrumentList) {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-6" style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                        <p>Instrument<span className="mandatory-star">*</span></p>
                        <select style={{ width: 250 }} onChange={(e) => this.chooseInstrument(e)} >
                            <option>Choose an Option...</option>
                            {instrumentList.map(val => (
                                <option key={val.organisation_assessment_credit__instrument} value={val.organisation_assessment_credit__instrument}>
                                    {`${val.organisation_assessment_credit__instrument__instrument_name} (${val.unsold_credits})`}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-6" style={{ display: 'flex', justifyContent: 'center' }}>
                        <button
                            className="btn btn-red btn-sm text-uppercase m-1"
                            onClick={() => this.resultNavigate(true)}
                            disabled={this.state.currentInstrumentId === 0}
                        >
                            Result
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    renderUploadSection() {
        return (
            <React.Fragment>
                <div className="instrument-select-message">
                    <p>** Please select an instrument</p>
                </div>
                <div className="bg-green rounded-top animation-fade-in">
                    <p className="text-center text-uppercase py-2 text-white mb-0">ASSESSMENTS RESPONSES UPLOAD</p>
                </div>

                <div className="container animation-fade-in" style={{ backgroundColor: '#5e5e5e' }}>
                    <div className="row p-2" >
                        <div className="pl-2 pr-2" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            {this.renderUploadButtons()}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderUploadButtons() {
        return (
            <React.Fragment>
                <button
                    className="btn btn-red btn-sm text-uppercase m-1"
                    disabled={this.state.currentInstrumentId === 0}
                    onClick={() => this.chooseFileFunc(true)}
                >
                    CHOOSE FILE
                </button>
                <button
                    className="btn btn-red btn-sm text-uppercase m-1"
                    disabled={!this.state.validateDisability || this.state.csvUploaded}
                    onClick={() => this.validateCsvFunc()}
                >
                    {this.state.validationText}
                </button>
                <button
                    className="btn btn-red btn-sm text-uppercase m-1"
                    style={{ width: 100 }}
                    disabled={!this.state.uploadDisability || this.state.csvUploaded}
                    onClick={() => this.uploadCsvFunc()}
                >
                    {this.state.uploaded_assessment_responses_loading ? <i className="fa fa-spinner fa-spin"></i> : 'UPLOAD'}
                </button>
            </React.Fragment>
        );
    }

    renderHotTable() {
        return (
            <HotTable
                data={this.state.csvData}
                colHeaders={true}
                rowHeaders={true}
                ref="hot"
                beforeChange={this.cellbeforechange}
                className={"animation-fade-in"}
                width="100%"
                height="600"
                stretchH="all"
                readOnly={this.state.readOnlyCsv}
                columns={[{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}]}
                afterValidate={this.hotAfterValidate}
                cells={this.getCellProperties}
            />
        );
    }

    getCellProperties = (row, col, prop) => {
        const cellProperties = {};

        if (row === 0) {
            cellProperties.readOnly = true;
        }

        this.state.errSaveIndex.forEach(index => {
            if (row === index.row && index.col.includes(col)) {
                cellProperties.className = 'cellErrorInvalid';
            }
        });

        return cellProperties;
    }

    renderChooseFileModal() {
        if (!this.state.chooseFile) return null;

        return (
            <ModalNew2
                heading="CHOOSE FILE"
                showModal={this.state.chooseFile}
                formData={[{
                    key: 'chooseFile',
                    type: 'file',
                    accept: '.csv',
                    value: '',
                    valid: false,
                    regex: ".+",
                    elementConfig: {
                        name: 'chooseFile',
                        label: '',
                        placeholder: 'Choose a file'
                    },
                    validation: {
                        required: false,
                        message: "is required"
                    },
                }]}
                action={this.chooseFileAction.bind(this)}
                toggleModal={this.chooseFileFunc.bind(this)}
                viewMessage={[{ text: '' }]}
                triggerType={"CANCEL"}
                singleButton={true}
                onlyCancel={true}
            />
        );
    }
}

const mapStateToProps = state => {

    const orgError = state.organisation.error;
    const orgLoading = state.organisation.loading;
    const organisationList = (!orgError && !orgLoading) ? state.organisation.organisation.data.organisation_list : [];

    const { batch_list_error, batch_list_loading } = state.managaBatchList;
    const batchList = (!batch_list_error && !batch_list_loading) ? state.managaBatchList.batch_list.data.organisation_batch_list : [];

    const { instrument_list_error, instrument_list_loading } = state.instrumentList;
    const instrumentList = (!instrument_list_error && !instrument_list_loading) ? state.instrumentList.instrument_list.data.organisation_credit_list : [];

    const { uploaded_assessment_responses_error, uploaded_assessment_responses_loading, uploaded_assessment_responses_error_data } = state.uploadAssessmentResponses;
    const uploaded_assessment_responses_data = (!uploaded_assessment_responses_error && !uploaded_assessment_responses_loading) ? state.uploadAssessmentResponses.uploaded_assessment_responses_data : { errors: [], status: false }

    const { uploaded_assessment_responses_result_list_error, uploaded_assessment_responses_result_list_loading, uploaded_assessment_responses_result_list_error_data, uploaded_assessment_responses_result_list_data } = state.uploadAssessmentResponsesResultList;


    const { uploaded_assessment_responses_result_view_error, uploaded_assessment_responses_result_view_loading, uploaded_assessment_responses_result_view_error_data, uploaded_assessment_responses_result_view_data } = state.uploadAssessmentResponsesResultView;




    return (
        {

            demoGraphicCsvUpload: state.demoGraphicCsvUpload,

            organisationList,
            orgError,
            orgLoading,

            batch_list_error,
            batch_list_loading,
            batchList,

            instrument_list_error,
            instrument_list_loading,
            instrumentList,

            uploaded_assessment_responses_error,
            uploaded_assessment_responses_loading,
            uploaded_assessment_responses_data,
            uploaded_assessment_responses_error_data,

            uploaded_assessment_responses_result_list_error,
            uploaded_assessment_responses_result_list_loading,
            uploaded_assessment_responses_result_list_error_data,
            uploaded_assessment_responses_result_list_data,

            uploaded_assessment_responses_result_view_error,
            uploaded_assessment_responses_result_view_loading,
            uploaded_assessment_responses_result_view_error_data,
            uploaded_assessment_responses_result_view_data


        }
    )
}

export default connect(mapStateToProps)(UploadAssessmentResponse)


// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/DetailLinks/uploadAssessmentResponse.jsx